import React from 'react';
import classnames from 'classnames';
import './Socials.scss';
import BrowserLink from '../../../../components/BrowserLink';

export function Socials({ socials, className, ...props }) {
  return (
    <ul className={classnames('Socials', className)}>
      {socials.map(({ url, icon }) => (
        <li className="Socials__item" key={url}>
          <BrowserLink
            href={url}
            className={classnames('Socials__link', `Socials__link_${icon}`)}
            target="_blank"
            rel="noreferrer"
          >
            <i className={classnames('fab', `fa-${icon}`)} />
          </BrowserLink>
        </li>
      ))}
    </ul>
  );
}
